/**
 * What a phone gets on a route built for a wide screen (ROADMAP "The phone
 * branch", item 8): one plain statement naming the feature, a way to take the
 * page to a desktop, and a way back to what the phone does. Never a broken
 * half-page.
 */
import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { DesktopWindows } from '@mui/icons-material';
import ShareLinkButton from './ShareLinkButton';
import { handoverFeatureName } from './phoneRoutes';
import FeatureExplainer, { featurePageFor } from './FeatureExplainer';

const DesktopHandover: React.FC = () => {
  const { pathname } = useLocation();
  const feature = handoverFeatureName(pathname) ?? 'This';
  // A feature page that ranks gets its explainer first, so the phone render —
  // what Google indexes — is the page's substance, not only this card.
  const explainer = featurePageFor(pathname);

  const card = (
    <Box
      component="section"
      aria-labelledby="desktop-handover-heading"
      sx={{ px: 3, py: 6, maxWidth: 480, mx: 'auto', textAlign: 'center' }}
    >
      <DesktopWindows sx={{ fontSize: 40, color: 'text.secondary', mb: 2 }} />
      <Typography id="desktop-handover-heading" component={explainer ? 'h2' : 'h1'} variant="h5" sx={{ fontWeight: 700, mb: 1.5 }}>
        {feature} works best on a desktop
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4 }}>
        It needs a wider screen than a phone. Send yourself this link and open it on a laptop.
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, alignItems: 'stretch' }}>
        <ShareLinkButton source="desktop_handover" />
        <Button
          component={RouterLink}
          to="/research"
          sx={{ textTransform: 'none', color: 'text.primary' }}
        >
          Look up a stock instead
        </Button>
      </Box>
    </Box>
  );

  if (!explainer) return card;
  return (
    <>
      <FeatureExplainer page={explainer} />
      <Box sx={{ borderTop: '1px solid', borderColor: 'divider' }}>{card}</Box>
    </>
  );
};

export default DesktopHandover;
